export default __webpack_public_path__ + "static/media/TF1-2.602f2fe1.jpg";